export class CatagoryTypeModel {
    public catId: number;
    public catType: string;
 }


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/catagoryType/catagory.type.model.ts